/* src/app/forms/produtos/amazon/criacao-produto/criacao-produto.component.css */
.mat-mdc-form-field {
  width: 70%;
  margin-top: 6px;
}
.action {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  margin-bottom: -12px;
  margin-top: -6px;
  height: 32px;
}
.dataName {
  display: flex;
  padding: 20px;
}
.dataName i {
  margin-left: 16px;
}
.vl {
  border-left: 1px solid gray;
  height: 70%;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.tree {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  margin-bottom: 10px;
}
.dataName .label {
  font-weight: 500;
  font-size: 100%;
}
.label0 {
  font-weight: 500;
  font-size: 100%;
}
.label1 {
  font-weight: 450;
  font-size: 100%;
  margin-top: 10px;
  margin-left: 10px;
}
.label2 {
  font-weight: 400;
  font-size: 100%;
  margin-top: 20px;
  margin-left: 20px;
}
.label3 {
  font-weight: 350;
  font-size: 100%;
  margin-top: 20px;
  margin-left: 30px;
}
.label4 {
  font-weight: 300;
  font-size: 100%;
  margin-top: 20px;
  margin-left: 40px;
}
.label5 {
  font-weight: 250;
  font-size: 90%;
  margin-top: 20px;
  margin-left: 50px;
}
.label6 {
  font-weight: 200;
  font-size: 90%;
  margin-top: 20px;
  margin-left: 60px;
}
.label7 {
  font-weight: 150;
  font-size: 80%;
  margin-top: 20px;
  margin-left: 70px;
}
.label8 {
  font-weight: 300;
  font-size: 100%;
}
.label9 {
  font-weight: 300;
  font-size: 100%;
}
.label10 {
  font-weight: 300;
  font-size: 100%;
}
ul {
  list-style-type: none;
}
.fa {
  font-size: larger;
}
.main-panel {
  display: flex;
  height: 100%;
  flex-direction: column;
  border: solid #e9ecef;
  border-radius: 4px;
  border-width: 0.1px;
  padding: 10px;
}
.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}
.left-panel {
  width: 50%;
  height: 100%;
}
.right-panel {
  width: 50%;
  height: 100%;
}
.data-item {
  display: flex;
  flex-direction: row;
}
.action mat-icon {
  cursor: pointer;
}
.action mat-form-field {
  width: 100%;
}
/*# sourceMappingURL=criacao-produto.component.css.map */
